import { useMutation } from "@tanstack/react-query";
import { aiApi } from "./ai.api";
import type {
  GenerateImageRequest,
  MediaPromptSuggestionsRequest,
} from "./types";

export const useGenerateImageMutation = () => {
  return useMutation({
    mutationFn: (data: GenerateImageRequest) => aiApi.generateImage(data),
  });
};

export const useGetMediaPromptSuggestionsMutation = () => {
  return useMutation({
    mutationFn: (data: MediaPromptSuggestionsRequest) =>
      aiApi.getMediaPromptSuggestions(data),
  });
};
